exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#app[data-v-338fd1b0]{font-family:Helvetica,sans-serif;text-align:center}.change-language[data-v-338fd1b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-row[data-v-338fd1b0]{margin-bottom:20px}img[data-v-338fd1b0]{width:500px}.light[data-v-338fd1b0]{color:#409eff}.normal[data-v-338fd1b0]{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-338fd1b0","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 199
// module chunks = 1